// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.media-player[data-v-029d3f65] {\n      max-width: 360px;\n}\naudio[data-v-029d3f65] {\n      width: 100%;\n}\n@media (max-width: 960px) {\n.media-player[data-v-029d3f65] {\n          max-width: 100%;\n}\n}\n  ", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
